import { useContext } from "react";
import { node } from "prop-types";
import { action, observable } from "mobx";
import { fetchProjectBudgetTrackingQuery, getUsersQuery } from "@query";
import { BudgetTrackingStoreContext } from "./BudgetTrackingStoreContext";

// =================== Context, Provider & Hook ===================
export const BudgetTrackingStoreProvider = ({ children }) => (
  <BudgetTrackingStoreContext.Provider value={new BudgetTrackingStore()}>
    {children}
  </BudgetTrackingStoreContext.Provider>
);

export const useBudgetTrackingStore = () => {
  const context = useContext(BudgetTrackingStoreContext);
  if (context === null) {
    throw new Error("BudgetTrackingStoreContext cannot be null, please add a context provider");
  }
  return context;
};


// =================== Store ===================
export class BudgetTrackingStore {

  @observable accessor jiraProject = true;
  @observable accessor cost = false;
  @observable accessor hours = false;

  @action async initProject(uuid) {
    return await fetchProjectBudgetTrackingQuery(uuid);
  }

  @action async getUsers() {
    return await getUsersQuery();
  }

  @action async getWorkTypeTable() {
    return this.workTypeTable;
  }

  @action setCost(cost) {
    this.cost = cost;
  }

  @action setHour(hour) {
    this.hours = hour;
  }
}

BudgetTrackingStoreProvider.propTypes = {
  children: node.isRequired,
};
